import React,{useState} from 'react'
import {Grid,Button,Pagination} from '@mui/material';
import './searchMainComp.css';
import { locations as cardLocations } from './../data/mock-data';
import CarouselCard from './CarouselCard';
import { FaFilter } from 'react-icons/fa';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import SearchFilters from './SearchFilters.js';
import Slider from "react-slick";
import { SampleNextArrow,SamplePrevArrow } from './HomeCaroused';


const SearchMainComp = ({type,setType}) => {


  const [currentPage,setCurrentPage] = useState(1)
  var countLength = Math.ceil(cardLocations.length/8);
  const [windowWidth, setWindowWidth] = useState(window.outerWidth);
  const [scrollY,setScrollY] = useState(window.scrollY);

  window.addEventListener("scroll",()=>{
    // setScrollY(window.scrollY)
    // console.log( (-1*(scrollY+80) ) )
  })

  window.addEventListener('resize',function (){
    setWindowWidth(window.outerWidth)
  })

  const containerStyle = {
    width: '100%',
    height: '100%'
  };
  
  const center = {
    lat: -3.745,
    lng: -38.523
  };


  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDx_nTwWLB8u7jpIpiXzuOkY7vk_LIq1fw"
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map)
  }, [])


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,    
  };


  return (
    <div onClick={()=>setType('')}>
        
        <div className='searchPageCompMain' id='h'>

<div className='srchCompSlidAlt'>
        <Slider {...settings}
arrows={true}
zIndex={2}
className={'as'}
centerPadding={'40px'}
prevArrow={<SamplePrevArrow />}
nextArrow={<SampleNextArrow />}
dots={false}>


    {
      cardLocations.map(v=>(
        <div className='searchCardCar'>
          <CarouselCard location={v} carousel={true} />
        </div>
      ))
    }


</Slider>
</div>

        <Grid container>
          
        <Grid item md={6}  className='firstSearchPageCompSubMain'>
        <Grid container rowSpacing={3} columnSpacing={3}>
        {cardLocations.map((location,i) => {
          if(i<currentPage*8 && i > ((currentPage-1)*8)-1 ){
          return (
            <Grid key={location.id} item xs={6} sm={windowWidth>650 ?  4 : 6}  md={6} lg={6}>
              <CarouselCard location={location} />
            </Grid>
          )};
        })}
        <div className='paginationDiv'>
        <Pagination count={countLength} page={currentPage} 
        onChange={(v,a)=>{
          setCurrentPage(Number(a)) 
        }}
        variant="outlined" />
        </div>
      </Grid>


        </Grid>
        <Grid item md={6} >
            <div className='mapDiv'  >
        {
          isLoaded &&
        <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        // onUnmount={onUnmount}
      >
      </GoogleMap>
        }
            </div>
        </Grid>
        </Grid>
        </div>
    </div>
  )
}

export default SearchMainComp